<template>
  <div
    v-if="data"
    class="courses-item"
    :class="{
      'courses-slide': slide,
      'courses-item-finish':
        data.status && data.status.toUpperCase() === 'FINISHED',
      'courses-item-opacity': opacity,
    }"
  >
    <div
      v-if="
        (data.status && data.status.toUpperCase() === 'FINISHED') ||
        (data.status && data.status.toUpperCase() === 'NEW') ||
        (data.status && data.status.toUpperCase() === 'DOWNLOADING') ||
        (data.status && data.status.toUpperCase() === 'PROGRESS')
      "
      class="courses-item-status"
      :class="{
        'status-work': data.status && data.status.toUpperCase() === 'PROGRESS',
        'status-finish':
          data.status && data.status.toUpperCase() === 'FINISHED',
        'status-new': data.status && data.status.toUpperCase() === 'NEW',
        'status-load':
          data.status && data.status.toUpperCase() === 'DOWNLOADING',
      }"
    >
      <img
        v-if="data.status && data.status.toUpperCase() === 'PROGRESS'"
        src="../assets/images/status/work.svg"
        alt=""
      />
      <img
        v-if="
          (data.status && data.status.toUpperCase() === 'FINISHED') || opacity
        "
        src="../assets/images/status/finish.svg"
        alt=""
      />
      <img
        v-if="data.status && data.status.toUpperCase() === 'NEW'"
        src="../assets/images/status/new.svg"
        alt=""
      />
      <img
        v-if="data.status && data.status.toUpperCase() === 'DOWNLOADING'"
        src="../assets/images/status/load.svg"
        alt=""
      />
      <span v-if="data.status && data.status.toUpperCase() === 'PROGRESS'">{{
        $t("status_progress")
      }}</span>
      <span
        v-if="
          (data.status && data.status.toUpperCase() === 'FINISHED') || opacity
        "
        >{{ $t("status_finished") }}</span
      >
      <span v-if="data.status && data.status.toUpperCase() === 'NEW'">{{
        $t("status_new")
      }}</span>
      <span v-if="data.status && data.status.toUpperCase() === 'DOWNLOADING'">{{
        $t("course_downloading")
      }}</span>
    </div>
    <i
      v-if="close"
      @click="$emit('close', { event: true, id: data.id })"
      class="courses-del-desires js-popup-desires fa-close"
    ></i>
    <div
      class="courses-item-photo"
      @click.prevent="upTop(`${url || '/course'}/${data.id}`)"
    >
      <img :src="$mediaUrl(data.image_url)" alt="" />
      <div
        v-if="data.status && data.status.toUpperCase() === 'PROGRESS'"
        class="courses-item-progres"
      >
        <span
          class="progres-line"
          :style="`width: ${(data.finished_lessons_count / data.lessons_count) * 100}%;`"
        ></span>
      </div>
    </div>
    <div class="courses-item-content">
      <div
        class="courses-info"
        @click.prevent="upTop(`${url || '/course'}/${data.id}`)"
      >
        <p>{{ data.category }}</p>
        <a :href="`${url || '/course'}/${data.id}`">{{ data.name }}</a>
      </div>
      <div class="courses-purchase">
        <a
          :href="`${url || '/course'}/${data.id}`"
          @click.prevent="upTop(`${url || '/course'}/${data.id}`)"
          class="courses-btn"
          >{{ $t("read") }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slide: {
      type: Boolean,
      default: false,
    },
    new_product: {
      type: Boolean,
      default: false,
    },
    load: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },
    data: {},
  },
  methods: {
    upTop(e) {
      window.scrollTo(0, 0);
      this.$router.push(e);
    },
  },
};
</script>
